export const instantAccessItems: string[] = [
  'All 10 complete workbooks, Grades 1–10',
  'Theory, worked examples, and assessments in every grade',
  'Diagnostic pre-assessments to place every student',
  'Ready-to-print guided and independent practice',
  'Print-ready and screen-ready — teach on paper or digitally',
  'Projects, quizzes, and full answer keys for the entire year',
]
